<template>
  <div>
    <v-date-picker
      v-model="datePicker"
      :min-date="minDate"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import VCalendar from 'v-calendar';

Vue.use(VCalendar);

export default {

  components: {
    VCalendar,
  },

  props: {
    date: {
      type: Date,
      default: undefined,
    },
    minDate: {
      type: Date,
      default: undefined,
    },
  },

  data() {
    return {
      datePicker: undefined,
      init: false,
    };
  },

  watch: {
    datePicker() {
      if (this.init) {
        this.dateChanged();
      } else {
        this.init = true;
      }
    },
  },

  mounted() {
    this.datePicker = this.date;
  },

  methods: {
    dateChanged() {
      this.$emit('dateChanged', this.datePicker);
    },
  },
};
</script>
